import { composite_products } from "./products/composite-products";
import { stockist } from "./products/stockist";
import { product_gallery } from "./products/product_gallery";
import { noble_checkout } from "./woocommerce/checkout";

jQuery(document).on('ready', function () {

    if (jQuery('body.elementor-page.floating-header').length) {
        let headerHeight = jQuery('header.site-header').height();
        let paddingTop = jQuery('body.elementor-page.floating-header .elementor-section.elementor-top-section:first-of-type()').css('padding-top').replace('px', '');

        // jQuery('body.elementor-page.floating-header .elementor-section.elementor-top-section:first-of-type()').css('padding-top', (headerHeight + parseInt(paddingTop)) + 'px');

        // outer
        jQuery(".header-slider-wrapper").css('margin-top', '-' + headerHeight + 'px');

        // inner
        jQuery(".header-slider-inner").css('padding-top', (headerHeight + parseInt(paddingTop)) + 'px');

    }

    //Menu Position Fix
    jQuery('.menu-item.menu-item-has-children').each(function () {
        let child = jQuery(this).find('.sub-menu');

        if (child.closest('.menu-item.mega-menu').length <= 0) {
            if ((child.offset().left + child.width()) > (jQuery(window).width() - 110)) {
                let marginDiff = (jQuery(window).width() - 110) - (child.offset().left + child.width());
                child.css('margin-left', (marginDiff) + 'px');
            }
        }
    });

    if (jQuery('form.cart.cart.composite-cart').length) {
        let compositeSettings = new composite_products;
    }

    //Get latest Fragments
    jQuery(document.body).trigger('wc_fragment_refresh');
});

// single products description as tabs
jQuery(document).ready(function () {
    let productGallery = new product_gallery;
    jQuery(".tab-toggle").on('click', function () {
        jQuery(this).toggleClass('open');
        jQuery(this).find(".single_product__benefits_description").toggleClass('open');
        jQuery(this).find(".single_product__ingriedients_description").toggleClass('open');
        jQuery(this).find(".single_product__fragrance_notes_description").toggleClass('open');
        // jQuery(".open_icon").toggleClass('close');
        // jQuery(".close_icon").toggleClass('open');

    });

    //Stockists
    if (jQuery('.stockists-container').length) {
        console.log("preparing the new stockist")
        let stockistSettings = new stockist;
    }
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

var _gaq = _gaq || []

jQuery('.add_to_cart_button:not(.product_type_variable, .product_type_grouped)').on('click', function () {

    //@ts-ignore
    _gaq.push(['_trackEvent', 'Products', 'Add to Cart', (jQuery(this).data('product_sku')) ? (jQuery(this).data('product_sku')) : ('#' + jQuery(this).data('product_id'))]);

});

//Prevent Emojis
jQuery('.gift-message,.input-text[name="order_comments"]').on('input paste', function () {
    let oldValue = (this as any).value;
    (this as any).value = (this as any).value.replace(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gm, '');
    if (oldValue != (this as any).value) {
        alert("You cannot use Emoji's in this text");
    }
});


//Mobile Menu settings
jQuery(document).on('ready', function () {
    jQuery('.mobile-nav .menu .sub-menu').each(function () {
        let section = jQuery(this);
        let height = section.height();
        section.css('--max_height', height + 'px');
    });
    jQuery('.mobile-nav .menu').addClass('menu-loaded');
    // jQuery('.mobile-nav .menu .menu-item>.sub-menu>.menu-item.menu-item-has-children').on('click', function (event) {
    //     if (event.target.classList.contains('menu-item-has-children') || event.target.parentElement.classList.contains('menu-item-has-children') || event.target.parentElement.parentElement.classList.contains('menu-item-has-children')) {
    //         event.stopPropagation();
    //         event.stopImmediatePropagation();
    //         event.preventDefault();
    //         this.classList.toggle('expanded');
    //     }
    // });
    jQuery('.mobile-nav .menu .menu-item.menu-item-has-children>.menu-item-link-container>a').on('click', function () {
        jQuery(this).closest('.menu-item').toggleClass('expanded');
    });
});

//Mega Menu Options
jQuery(document).on('ready', function () {
    jQuery('.main-nav .menu-item a').on('click', function (event) {
        if (this.getAttribute('href') == '#') {
            event.preventDefault();
        }
    });

    jQuery('.menu .menu-item.mega-menu').each(function () {
        let megaMenu = new mega_menu(this);
    });
});

class mega_menu {
    element;

    constructor(element) {
        this.element = jQuery(element);
        this.setColumnCount();

        jQuery(window).on('resize', () => {
            this.setColumnCount();
        });
    }

    setColumnCount() {
        let _this = this;
        let maxWidth = 0;
        this.element.find('.menu-item').each(function () {
            let width = _this.measureWidth(this);
            if (width > maxWidth) maxWidth = width;
        });

        let containerWidth = this.element.find('.sub-menu-container').width();
        let columnCount = 4;

        while ((containerWidth / columnCount) < maxWidth && columnCount > 2) {
            columnCount--;
        }

        this.element.css('--column_count', columnCount);
    }

    measureWidth(selector) {
        var item = jQuery(selector).eq(0);
        var pos = item.css("position");
        item.css("position", "absolute");
        var width = item.width();
        item.css("position", pos);
        return (width as number);
    }
}

let checkout = new noble_checkout;

//Trigger CF7 Popup
document.addEventListener('wpcf7mailsent', function (event) {
    if ('144332' == event.detail.contactFormId) {
        elementorFrontend.documentsManager.documents[159939].showModal();
    }
}, false);